// import React, { useState, useEffect, useCallback } from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import { jwtDecode } from "jwt-decode";
// import {
//   getStudentDetails,
//   updateStudentText,
// } from "../../services/admin.services";
// import { toast } from "react-toastify"; // Assuming react-toastify is installed

// const EditableNotes = ({ studentId, studentDetails }) => {
//   // State management
//   const [activeTab, setActiveTab] = useState("note");
//   const [editing, setEditing] = useState(false);
//   const [editValue, setEditValue] = useState("");
//   const [notes, setNotes] = useState("");
//   const [userRole, setUserRole] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [fullscreen, setFullscreen] = useState(false);
//   const [error, setError] = useState(null);

//   // Get user role from token
//   useEffect(() => {
//     const getUserRole = () => {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         setError("Authentication token not found");
//         setLoading(false);
//         return;
//       }

//       try {
//         const decodedToken = jwtDecode(token);
//         setUserRole(decodedToken.role);
//       } catch (error) {
//         console.error("Error decoding token:", error);
//         setError("Authentication error");
//         setLoading(false);
//       }
//     };

//     getUserRole();
//   }, []);

//   // Memoized fetch function to avoid recreating on each render
//   const fetchStudentNotes = useCallback(async () => {
//     if (!userRole) return;

//     setLoading(true);
//     setError(null);

//     try {
//       // Case 1: User is a student viewing their own notes
//       if (userRole === "student" && studentDetails) {
//         const notesContent = studentDetails.final_university_details_text || "";
//         setNotes(notesContent || "No notes available.");
//         setEditValue(notesContent || "No notes available.");
//         return;
//       }

//       // Case 2: Admin or counselor viewing student notes
//       if (userRole !== "student") {
//         // Try to get from cache first
//         const cacheKey = `notes_${studentId}`;
//         const storedNotes = localStorage.getItem(cacheKey);
//         const cacheTimestamp = localStorage.getItem(`${cacheKey}_timestamp`);
//         const isCacheValid =
//           cacheTimestamp &&
//           Date.now() - parseInt(cacheTimestamp) < 1000 * 60 * 5; // 5 min cache

//         if (storedNotes && isCacheValid) {
//           setNotes(storedNotes);
//           setEditValue(storedNotes);
//         } else {
//           // Fetch fresh data
//           const response = await getStudentDetails(studentId);
//           const notesContent = response?.final_university_details_text || "";

//           setNotes(notesContent || "No notes available.");
//           setEditValue(notesContent || "No notes available.");

//           // Update cache
//           localStorage.setItem(cacheKey, notesContent);
//           localStorage.setItem(`${cacheKey}_timestamp`, Date.now().toString());
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching notes:", error);
//       setError("Failed to load notes. Please try again.");
//       setNotes("Error loading notes.");
//       setEditValue("Error loading notes.");
//     } finally {
//       setLoading(false);
//     }
//   }, [userRole, studentId, studentDetails]);

//   // Fetch notes when dependencies change
//   useEffect(() => {
//     if (userRole) {
//       fetchStudentNotes();
//     }
//   }, [userRole, fetchStudentNotes]);

//   // Save edited notes
//   const handleSaveEdit = async () => {
//     if (userRole === "student") {
//       toast.error("Students cannot edit notes");
//       return;
//     }

//     setSaving(true);
//     try {
//       const formData = { final_university_details_text: editValue };
//       await updateStudentText(studentId, formData);

//       // Update state and cache
//       setNotes(editValue);
//       localStorage.setItem(`notes_${studentId}`, editValue);
//       localStorage.setItem(
//         `notes_${studentId}_timestamp`,
//         Date.now().toString()
//       );

//       setEditing(false);
//       toast.success("Notes saved successfully!");
//     } catch (error) {
//       console.error("Failed to save notes:", error);
//       toast.error("Failed to save notes. Please try again.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // Cancel editing
//   const handleCancelEdit = () => {
//     setEditValue(notes);
//     setEditing(false);
//   };

//   // Toggle fullscreen mode
//   const toggleFullscreen = () => {
//     setFullscreen((prev) => !prev);
//   };

//   // Empty state component
//   const EmptyState = () => (
//     <div className="flex flex-col items-center justify-center p-8 text-center">
//       <svg
//         className="w-16 h-16 text-gray-400"
//         fill="none"
//         stroke="currentColor"
//         viewBox="0 0 24 24"
//       >
//         <path
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           strokeWidth={2}
//           d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//         />
//       </svg>
//       <p className="mt-4 text-lg text-gray-600">No notes available yet</p>
//       {userRole !== "student" && (
//         <button
//           onClick={() => setEditing(true)}
//           className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
//         >
//           Add Notes
//         </button>
//       )}
//     </div>
//   );

//   // Error state component
//   const ErrorState = () => (
//     <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
//       <div className="flex items-center">
//         <svg
//           className="w-6 h-6 text-red-500 mr-3"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={2}
//             d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//           />
//         </svg>
//         <p className="text-red-700">{error}</p>
//       </div>
//       <button
//         onClick={fetchStudentNotes}
//         className="mt-3 bg-red-100 text-red-700 px-3 py-1 rounded hover:bg-red-200 transition"
//       >
//         Retry
//       </button>
//     </div>
//   );

//   // Main UI
//   return (
//     <div
//       className={`flex flex-col ${
//         fullscreen
//           ? "fixed inset-0 bg-white z-50 p-8 overflow-auto"
//           : "h-full bg-gray-50 rounded-lg shadow"
//       } transition-all duration-300`}
//     >
//       <div className="flex border-b">
//         <button
//           className={`px-6 py-3 font-medium transition ${
//             activeTab === "note"
//               ? "border-b-2 border-blue-500 text-blue-500"
//               : "text-gray-600 hover:text-gray-800"
//           }`}
//           onClick={() => setActiveTab("note")}
//         >
//           Notes
//         </button>
//       </div>

//       <div className="flex-1 p-4">
//         {loading ? (
//           <div className="flex justify-center items-center h-64">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//           </div>
//         ) : error ? (
//           <ErrorState />
//         ) : (
//           <>
//             {activeTab === "note" && (
//               <div
//                 className={`bg-green-50 border-l-4 border-green-500 p-6 rounded-md shadow-md relative transition-all duration-300`}
//               >
//                 {fullscreen && (
//                   <button
//                     className="absolute top-6 right-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition flex items-center"
//                     onClick={toggleFullscreen}
//                   >
//                     <svg
//                       className="w-4 h-4 mr-2"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M6 18L18 6M6 6l12 12"
//                       />
//                     </svg>
//                     Exit Fullscreen
//                   </button>
//                 )}

//                 <div className="flex justify-between items-center mb-4">
//                   <h3 className="text-xl font-semibold text-green-700">
//                     General Notes
//                   </h3>
//                   {userRole !== "student" && !editing && (
//                     <button
//                       onClick={() => setEditing(true)}
//                       className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition flex items-center"
//                     >
//                       <svg
//                         className="w-4 h-4 mr-2"
//                         fill="none"
//                         stroke="currentColor"
//                         viewBox="0 0 24 24"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
//                         />
//                       </svg>
//                       Edit Notes
//                     </button>
//                   )}
//                 </div>

//                 {!notes || notes === "No notes available." ? (
//                   !editing && <EmptyState />
//                 ) : !editing ? (
//                   <div
//                     className={`overflow-auto prose max-w-none ${
//                       fullscreen ? "h-screen pb-24" : "h-72"
//                     } transition-all duration-300`}
//                   >
//                     <div
//                       className="text-gray-700"
//                       dangerouslySetInnerHTML={{ __html: notes }}
//                     ></div>
//                   </div>
//                 ) : null}

//                 {editing && (
//                   <div className={`${fullscreen ? "h-screen" : "h-96"}`}>
//                     <ReactQuill
//                       theme="snow"
//                       value={editValue}
//                       onChange={setEditValue}
//                       className={`bg-white ${
//                         fullscreen ? "h-4/5" : "h-80"
//                       } mb-4 rounded`}
//                       modules={{
//                         toolbar: [
//                           [{ header: [1, 2, 3, false] }],
//                           ["bold", "italic", "underline", "strike"],
//                           [{ list: "ordered" }, { list: "bullet" }],
//                           [{ color: [] }, { background: [] }],
//                           ["link", "image"],
//                           ["clean"],
//                         ],
//                       }}
//                     />
//                   </div>
//                 )}

//                 <div className="mt-4 flex gap-2">
//                   {editing && (
//                     <div className="flex space-x-2">
//                       <button
//                         onClick={handleCancelEdit}
//                         className="bg-gray-300 px-4 py-2 rounded-md hover:bg-gray-400 transition flex items-center"
//                         disabled={saving}
//                       >
//                         <svg
//                           className="w-4 h-4 mr-2"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M6 18L18 6M6 6l12 12"
//                           />
//                         </svg>
//                         Cancel
//                       </button>
//                       <button
//                         onClick={handleSaveEdit}
//                         className={`bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition flex items-center ${
//                           saving ? "opacity-75 cursor-not-allowed" : ""
//                         }`}
//                         disabled={saving}
//                       >
//                         {saving ? (
//                           <>
//                             <svg
//                               className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                             >
//                               <circle
//                                 className="opacity-25"
//                                 cx="12"
//                                 cy="12"
//                                 r="10"
//                                 stroke="currentColor"
//                                 strokeWidth="4"
//                               ></circle>
//                               <path
//                                 className="opacity-75"
//                                 fill="currentColor"
//                                 d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                               ></path>
//                             </svg>
//                             Saving...
//                           </>
//                         ) : (
//                           <>
//                             <svg
//                               className="w-4 h-4 mr-2"
//                               fill="none"
//                               stroke="currentColor"
//                               viewBox="0 0 24 24"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M5 13l4 4L19 7"
//                               />
//                             </svg>
//                             Save
//                           </>
//                         )}
//                       </button>
//                     </div>
//                   )}
//                   {!editing &&
//                     !fullscreen &&
//                     notes &&
//                     notes !== "No notes available." && (
//                       <button
//                         onClick={toggleFullscreen}
//                         className="ml-auto bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 transition flex items-center"
//                       >
//                         <svg
//                           className="w-4 h-4 mr-2"
//                           fill="none"
//                           stroke="currentColor"
//                           viewBox="0 0 24 24"
//                         >
//                           <path
//                             strokeLinecap="round"
//                             strokeLinejoin="round"
//                             strokeWidth={2}
//                             d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
//                           />
//                         </svg>
//                         Expand
//                       </button>
//                     )}
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default EditableNotes;

import React, { useState, useEffect, useCallback } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { jwtDecode } from "jwt-decode";
import {
  getStudentDetails,
  updateStudentText,
} from "../../services/admin.services";
import { toast } from "react-toastify";

const EditableNotes = ({ studentId, studentDetails }) => {
  const [activeTab, setActiveTab] = useState("note");
  const [editing, setEditing] = useState(false);
  const [editValue, setEditValue] = useState("");
  const [notes, setNotes] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [fullscreen, setFullscreen] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUserRole = () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Authentication token not found");
        setLoading(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        setUserRole(decodedToken.role);
      } catch (error) {
        console.error("Error decoding token:", error);
        setError("Authentication error");
        setLoading(false);
      }
    };

    getUserRole();
  }, []);

  const fetchStudentNotes = useCallback(async () => {
    if (!userRole || !studentId) return;

    setLoading(true);
    setError(null);

    try {
      let notesContent = "";

      if (userRole === "student" && studentDetails) {
        notesContent = studentDetails.final_university_details_text || "";
      } else {
        const response = await getStudentDetails(studentId);
        console.log("responseadmin", response);

        notesContent = response?.data.final_university_details_text || "";
        console.log("notesContent", notesContent);
      }

      const displayNotes = notesContent || "No notes available.";
      setNotes(displayNotes);
      setEditValue(displayNotes);
    } catch (error) {
      console.error("Error fetching notes:", error);
      setError("Failed to load notes. Please try again.");
      setNotes("Error loading notes.");
      setEditValue("Error loading notes.");
    } finally {
      setLoading(false);
    }
  }, [userRole, studentId, studentDetails]);

  useEffect(() => {
    if (userRole) {
      fetchStudentNotes();
    }
  }, [userRole, fetchStudentNotes]);

  const handleSaveEdit = async () => {
    if (userRole === "student") {
      toast.error("Students cannot edit notes");
      return;
    }

    setSaving(true);
    try {
      const formData = { final_university_details_text: editValue };
      await updateStudentText(studentId, formData);

      setNotes(editValue);
      setEditing(false);
      toast.success("Notes saved successfully!");
    } catch (error) {
      console.error("Failed to save notes:", error);
      toast.error("Failed to save notes. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const handleCancelEdit = () => {
    setEditValue(notes);
    setEditing(false);
  };

  const toggleFullscreen = () => {
    setFullscreen((prev) => !prev);
  };

  const EmptyState = () => (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <svg
        className="w-16 h-16 text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
        />
      </svg>
      <p className="mt-4 text-lg text-gray-600">No notes available yet</p>
      <button
        onClick={() => setEditing(true)}
        className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
      >
        Add Notes
      </button>
    </div>
  );

  const ErrorState = () => (
    <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
      <div className="flex items-center">
        <svg
          className="w-6 h-6 text-red-500 mr-3"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <p className="text-red-700">{error}</p>
      </div>
      <button
        onClick={fetchStudentNotes}
        className="mt-3 bg-red-100 text-red-700 px-3 py-1 rounded hover:bg-red-200 transition"
      >
        Retry
      </button>
    </div>
  );

  return (
    <div
      className={`flex flex-col ${
        fullscreen
          ? "fixed inset-0 bg-white z-50 p-8 overflow-auto"
          : "h-full bg-gray-50 rounded-lg shadow"
      } transition-all duration-300`}
    >
      <div className="flex border-b">
        <button
          className={`px-6 py-3 font-medium transition ${
            activeTab === "note"
              ? "border-b-2 border-blue-500 text-blue-500"
              : "text-gray-600 hover:text-gray-800"
          }`}
          onClick={() => setActiveTab("note")}
        >
          Notes
        </button>
      </div>

      <div className="flex-1 p-4">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
          </div>
        ) : error ? (
          <ErrorState />
        ) : (
          <>
            {activeTab === "note" && (
              <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-md shadow-md relative transition-all duration-300">
                {fullscreen && (
                  <button
                    className="absolute top-6 right-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 transition flex items-center"
                    onClick={toggleFullscreen}
                  >
                    Exit Fullscreen
                  </button>
                )}

                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-xl font-semibold text-green-700">
                    General Notes
                  </h3>
                  {userRole !== "student" &&
                    !editing &&
                    notes !== "No notes available." && (
                      <button
                        onClick={() => setEditing(true)}
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition"
                      >
                        Edit Notes
                      </button>
                    )}
                </div>

                {!editing ? (
                  !notes || notes === "No notes available." ? (
                    userRole !== "student" ? (
                      <EmptyState />
                    ) : (
                      <div className="text-gray-500">No notes available.</div>
                    )
                  ) : (
                    <div
                      className={`overflow-auto prose max-w-none ${
                        fullscreen ? "h-screen pb-24" : "h-72"
                      }`}
                    >
                      <div
                        className="text-gray-700 ql-editor"
                        dangerouslySetInnerHTML={{ __html: notes }}
                      />
                    </div>
                  )
                ) : (
                  <div className={`${fullscreen ? "h-screen" : "h-96"}`}>
                    <ReactQuill
                      theme="snow"
                      value={editValue}
                      onChange={setEditValue}
                      className={`bg-white ${
                        fullscreen ? "h-4/5" : "h-80"
                      } mb-4 rounded`}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, 3, false] }],
                          ["bold", "italic", "underline", "strike"],
                          [{ list: "ordered" }, { list: "bullet" }],
                          [{ color: [] }, { background: [] }],
                          ["link", "image"],
                          ["clean"],
                        ],
                      }}
                    />
                  </div>
                )}

                <div className="mt-4 flex gap-2">
                  {editing && (
                    <>
                      <button
                        onClick={handleCancelEdit}
                        className="bg-gray-300 px-4 py-2 rounded-md hover:bg-gray-400 transition"
                        disabled={saving}
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handleSaveEdit}
                        className={`bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition ${
                          saving ? "opacity-75 cursor-not-allowed" : ""
                        }`}
                        disabled={saving}
                      >
                        {saving ? "Saving..." : "Save"}
                      </button>
                    </>
                  )}
                  {!editing &&
                    !fullscreen &&
                    notes &&
                    notes !== "No notes available." && (
                      <button
                        onClick={toggleFullscreen}
                        className="ml-auto bg-purple-500 text-white px-4 py-2 rounded hover:bg-purple-600 transition"
                      >
                        Expand
                      </button>
                    )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default EditableNotes;
